import { render, staticRenderFns } from "./NotificationTemplateEditorModal.vue?vue&type=template&id=761801a6&scoped=true"
import script from "./NotificationTemplateEditorModal.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateEditorModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateEditorModal.vue?vue&type=style&index=0&id=761801a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761801a6",
  null
  
)

export default component.exports